module.exports = __webpack_public_path__ + "assets/img/btn-detail-fc3e7c44.png";